<template>
  <v-navigation-drawer
    dark
    fixed
    app
    :value="navbarShow"
    width="184"
    class="app-drawer"
    @input="stateNavbarShow"
    mobile-breakpoint="768"
  >
    <div class="app-drawer__header">
      <img :src="logoSrc" :alt="logoAlt" />
    </div>
    <app-drawer-list :routes="protectedRoute" icon-show />
  </v-navigation-drawer>
</template>

<script>
// import { mapGetters } from 'vuex';
import { protectedRoute } from "@/router/config";
import AppDrawerList from "@/components/layout/AppDrawerList.vue";
import extendedConfig from "../../tenants.js";

export default {
  name: "AppDrawer",
  components: {
    AppDrawerList
  },
  data: () => ({
    navbarShow: true, // TODO: Needed to be stored in store
    protectedRoute: protectedRoute
  }),
  computed: {
    logoSrc() {
      if (extendedConfig.VUE_TENANT_ID=='brainhealthinitiative') return require('@/assets/bhi_logo.png') // TODO: require(extendedConfig.VUE_MAIN_LOGO) is not working
      if (extendedConfig.VUE_TENANT_ID=='olympianbydesign') return require('@/assets/obd_logo.png')
      return extendedConfig.VUE_MAIN_LOGO || require('@/assets/logo-keep-rising-white.png')
    },
    logoAlt() {
      return extendedConfig.VUE_LOGO_ALT || extendedConfig.VUE_MAIN_TITLE;
    }
  },
  methods: {
    stateNavbarShow(state) {
      // this.$store.dispatch('NavbarState', { state });
    }
  }
};
</script>
<style lang="scss">
.app-drawer {
  background-color: var(--main-color) !important;
  &__header {
    padding: 31px 29px;
    text-align: right;
  }
}
</style>
